export default __webpack_public_path__ + "static/avatar-alex-allan2-f44086e2f22fc5dbaa58729eda477891.jpg";